export default __webpack_public_path__ + "static/media/ABM Staff Instituciones.fb51cabd.xlsx";